import { faker } from '@faker-js/faker'

import { UserReservationCancellationReason } from '../../contracts/reservation'
import { SolarResponse } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getReservationCancelReason = asBuilder<SolarResponse<UserReservationCancellationReason[]>>(
  (): SolarResponse<UserReservationCancellationReason[]> => {
    return {
      reason: 'SUCCESS',
      msgCode: null,
      succeeded: true,
      data: faker.helpers.multiple(
        () => ({
          code: faker.string.uuid(),
          codeInfo: faker.string.uuid(),
          codeName: faker.string.uuid(),
          codeType: 'RSVT_CANCEL_REASON',
          id: faker.number.int(),
          orders: faker.number.int(),
          pcode: faker.string.uuid(),
        }),
        { count: faker.number.int({ min: 1, max: 10 }) },
      ),
    }
  },
)
